"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// Note: we disable the triple-equals rule in several places as many of the tree node properties come from the server as strings and are then
// converted to numbers / etc. So to ensure comparisons are done correctly, we intentionally loosely compare many of the properties.
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Tree_CheckedText: "Checked, ",
                Tree_ChildrenText: "Node Has {0} Children, ",
                Tree_CollapsedText: "Collapsed, ",
                Tree_ExpandedText: "Expanded, ",
                Tree_NodeLabel: "TreeNode {0} is ",
                Tree_PartialCheckedText: "Partially Checked, ",
                Tree_Posinset: "This Node is {0} out of {1} Children of its Parent Node, ",
                Tree_RangeSelectionText: "Multiple nodes are selected from node {0} to node {1}, ",
                Tree_SingleSelectionText: "Selected, ",
                Tree_ToggleSelectionText: "Unselected, ",
                Tree_UncheckedText: "Unchecked, ",
            },
        });
        /**
         * Class represent the tree control.
         */
        var Tree = /** @class */ (function (_super) {
            __extends(Tree, _super);
            function Tree() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Tree.prototype.init = function (data, element) {
                var _this = this;
                this.currentHowSelected = 0;
                _super.prototype.init.call(this, data, element);
                this.selectedNodes = [];
                this.idMap = {};
                // methods will be overwritten if telemetry is enabled
                this.RecordRemoveTelemetry = function () { };
                this.RecordAddTelemetry = function () { };
                this.RecordEditTelemetry = function () { };
                this.Nodes = [];
                // Indicates the current navigation direction
                this.direction = $dyn.ui.Tree.NavigationDirection.Down;
                $dyn.observe(this.Border, function (value) {
                    if ((value === "Auto") || (value === "None")) {
                        $(element).removeClass("treeView-border");
                    }
                    else {
                        $(element).addClass("treeView-border");
                    }
                });
                this.CheckBoxCascade = $dyn.computed(function () {
                    // tslint:disable-next-line: triple-equals
                    return $dyn.value(_this.CheckBox) == true && $dyn.util.stringToBoolean($dyn.value(_this.CascadeSelect)) == true;
                });
                // If the tree nodes observer is not going to render, cause a render here
                var treeNodesLen = $dyn.length(this.TreeNodes);
                if (element && (treeNodesLen === undefined || treeNodesLen === 0)) {
                    this.renderTree();
                }
                // this TreeNodes property doesn't hold the tree data, rather holds the node deltas from the server.
                // Nodes holds the roots(for tree) or children(for any node)
                $dyn.observe(this.TreeNodes, function (treeNodes) {
                    var e_1, _a;
                    // convert the flat TreeNodes array into a node hierarchy
                    if ($dyn.length(treeNodes) > 0) {
                        var shouldCommit = false;
                        try {
                            for (var treeNodes_1 = __values(treeNodes), treeNodes_1_1 = treeNodes_1.next(); !treeNodes_1_1.done; treeNodes_1_1 = treeNodes_1.next()) {
                                var treeNode = treeNodes_1_1.value;
                                var node = _this.convertNode(treeNode);
                                // tslint:disable-next-line: triple-equals
                                if (node.CommandRequest == $dyn.ui.TreeCommands.Edit) {
                                    _this.updateNode(node);
                                    // tslint:disable-next-line: triple-equals
                                }
                                else if (node.CommandRequest == $dyn.ui.TreeCommands.Delete) {
                                    var changeHandled = _this.deleteNode(node);
                                    shouldCommit = shouldCommit || !changeHandled;
                                }
                                else {
                                    var changeHandled = _this.addNode(node);
                                    shouldCommit = shouldCommit || !changeHandled;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (treeNodes_1_1 && !treeNodes_1_1.done && (_a = treeNodes_1.return)) _a.call(treeNodes_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        // TreeNodes should be clear, once it is processed
                        _this.TreeNodes([]);
                        // commitChange true indicates that the action is not taken care of and rerendering the tree should take place
                        if (shouldCommit) {
                            _this.renderTree();
                        }
                    }
                });
                if (this.Root && this.Root.serializeTransitState) {
                    this.TransitStateSubscriptionId = this.Root.serializeTransitState.subscribe(this.onSerializeTransitState.bind(this));
                }
                this.__updateScrollOnNavigation = function () {
                    var selectedNode = _this.SelectedNode();
                    _this.currentHowSelected = 0;
                    _this.updateScrollIntoView(selectedNode);
                };
                // Watching the resetShellOnNavigation event to fix the scrolling position of selected node.
                $(document.body).on("resetShellOnNavigation", this.__updateScrollOnNavigation);
            };
            /** @inheritdoc */
            Tree.prototype.getTaskGuideParams = function (options) {
                options = _super.prototype.getTaskGuideParams.call(this, options);
                var nodePath = options.arguments && options.arguments.length > 0 ? options.arguments[0].split("\\") : "";
                if (nodePath !== "") {
                    // Traverse the tree to the node in case of duplicate children
                    var formattedString = nodePath[0].indexOf('"') > -1 ? "[title='{0}']" : '[title="{0}"]';
                    var node = $(this.element).find($dyn.format(formattedString, nodePath[0]));
                    if (node && $(node)) {
                        var nodeHeader = $(node).closest(".treeView-treeItem-header");
                        for (var i = 1; i < nodePath.length; i++) {
                            formattedString = nodePath[i].indexOf('"') > -1 ? "[title='{0}']" : '[title="{0}"]';
                            node = $(nodeHeader).parent().find($dyn.format(formattedString, nodePath[i]));
                            if (node && $(node)) {
                                nodeHeader = $(node).closest(".treeView-treeItem-header");
                            }
                        }
                        if (nodeHeader) {
                            options.target = $(nodeHeader);
                        }
                    }
                }
                // If we didn't find a node, just point to the whole tree and let the user figure it out
                if (!options.target || !options.target.length) {
                    options.target = $(this.element);
                }
                return options;
            };
            /**
             * Get node information for a given id.
             * @param nodeId Tree Node id.
             * @returns Node information.
             */
            Tree.prototype.NodeData = function (nodeId) {
                return this.idMap[nodeId];
            };
            /**
             * Set node information for a given id.
             * @param nodeId Tree Node id.
             * @param nodeData Node information.
             */
            Tree.prototype.SetNodeData = function (nodeId, nodeData) {
                if (nodeData) {
                    this.idMap[nodeId] = nodeData;
                }
                else {
                    if (this.idMap[nodeId] && this.idMap[nodeId].ReactNode) {
                        delete this.idMap[nodeId].ReactNode;
                    }
                    delete this.idMap[nodeId];
                }
            };
            /** Called when the new window is opened. */
            Tree.prototype.onSerializeTransitState = function () {
                $dyn.applyFunction(this.Reserialize, this);
            };
            /**
             * Tree node check box click handler.
             * @param treeNode Current react tree node.
             * @param evt The click event.
             */
            Tree.prototype.CheckBoxClick = function (treeNode, evt) {
                if (this.allowUserChanges()) {
                    var checkedValue = treeNode.CheckedState();
                    if (checkedValue === $dyn.ui.CheckedState.Checked) {
                        checkedValue = $dyn.ui.CheckedState.Unchecked;
                    }
                    else {
                        checkedValue = $dyn.ui.CheckedState.Checked;
                    }
                    treeNode.CheckedState(checkedValue);
                    this.SetNodeCheckBox(treeNode.NodeData(), checkedValue, true);
                }
                if (evt) {
                    evt.stopPropagation();
                }
            };
            /**
             * Tree node click handler, should select the clicked node.
             * @param treeNode Current react tree node.
             * @param evt The click event.
             */
            Tree.prototype.ClickNode = function (treeNode, evt) {
                var selectAction = $dyn.ui.Tree.SelectionAction.Single;
                if (!$dyn.value(this.SingleSelect)) {
                    if (evt.shiftKey) {
                        selectAction = $dyn.ui.Tree.SelectionAction.Range;
                    }
                    else if (evt.ctrlKey) {
                        selectAction = $dyn.ui.Tree.SelectionAction.Append;
                    }
                }
                this.SelectNode(treeNode, $dyn.ui.Tree.HowSelected.ByMouse, selectAction);
                this.formActiveRowChangedNotify();
            };
            /**
             * Tree node expand/collapse button click handler.
             * @param treeNode Current react tree node.
             * @param evt The click event.
             */
            Tree.prototype.ButtonClick = function (treeNode, evt) {
                this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.mouse };
                this.ExpandCollapse(treeNode, !treeNode.Expanded());
                if (evt) {
                    evt.stopPropagation();
                }
            };
            /**
             * Apply the rename of a tree node label edit action.
             * @param applyChanges Flag indicates if the label edit should be commit (true) or rolledback (false)
             * @param newValue New label.
             * @param originalValue Old label.
             * @param nodeId Current node ID.
             */
            Tree.prototype.ApplyRename = function (applyChanges, newValue, originalValue, nodeId) {
                this.Editing = false;
                if (applyChanges && originalValue !== newValue) {
                    originalValue = newValue;
                    var args = [newValue];
                    $dyn.getFunction(this.NodeNameChanged)(args);
                    this.RecordEditTelemetry(nodeId);
                }
            };
            /**
             * Add the specified node into the selection list.
             * @param treeNode Current react tree node.
             */
            Tree.prototype.AddSelection = function (treeNode) {
                var treeNodeId = treeNode.NodeId();
                // tslint:disable-next-line: triple-equals
                if ((this.selectedNodes.length === 0) || (this.selectedNodes.some(function (element) { return (element.NodeId() == treeNodeId); }) === false)) {
                    this.selectedNodes.push(treeNode);
                    this.updateScrollIntoView(treeNode);
                }
            };
            /**
             * Remove the specified node from the selection list.
             * @param treeNode Current react tree node.
             */
            Tree.prototype.RemoveSelection = function (treeNode) {
                this.RemoveNodeFromArray(this.selectedNodes, treeNode.NodeId(), this.nodeIdComparer);
            };
            /**
             * Key down handler function for tree control.
             * @param evt The key down event.
             */
            Tree.prototype.keyDown = function (evt) {
                if (evt.which === $dyn.ui.KeyCodes.upArrow) {
                    this.SelectNextVisible(evt, false);
                    evt.preventDefault();
                }
                else if (evt.which === $dyn.ui.KeyCodes.downArrow) {
                    this.SelectNextVisible(evt, true);
                    evt.preventDefault();
                }
                else if (evt.which === $dyn.ui.KeyCodes.home && !this.Editing) {
                    this.SelectRoot();
                    evt.preventDefault();
                }
                else if (evt.which === $dyn.ui.KeyCodes.end && !this.Editing) {
                    this.SelectLastVisibleRoot();
                    evt.preventDefault();
                }
                else if (evt.which === $dyn.ui.KeyCodes.leftArrow && !this.Editing) {
                    this.CollapseSelectedNode();
                    evt.preventDefault();
                }
                else if (evt.which === $dyn.ui.KeyCodes.rightArrow && !this.Editing) {
                    this.ExpandSelectedNode();
                    evt.preventDefault();
                }
                else if ((evt.which === $dyn.ui.KeyCodes.spacebar || evt.which === $dyn.ui.KeyCodes.enter) && !this.Editing) {
                    this.ToggleSelectedNodeCheck(evt);
                    this.formActiveRowChangedNotify();
                    evt.preventDefault();
                }
                else if (evt.which === $dyn.ui.KeyCodes.letterR && evt.altKey) {
                    this.RenameNode();
                    evt.preventDefault();
                }
                else if (evt.which === $dyn.ui.KeyCodes.enter && this.Editing) {
                    this.handleRenameActions(evt, false);
                }
                else if (evt.which === $dyn.ui.KeyCodes.esc && this.Editing) {
                    this.handleRenameActions(evt, true);
                }
            };
            /** Tree focus in call back function, adds the tree focus class. */
            Tree.prototype.focusInCallBack = function () {
                this.element.classList.add("focused");
            };
            /** Tree focus out call back function, removes the tree focus class. */
            Tree.prototype.focusOutCallBack = function () {
                this.element.classList.remove("focused");
            };
            /** @inheritdoc. */
            Tree.prototype.dispose = function () {
                ReactDOM.unmountComponentAtNode(this.element);
                $(document.body).off("resetShellOnNavigation", this.__updateScrollOnNavigation);
                _super.prototype.dispose.call(this);
            };
            /**
             * Expand or collapse a tree node.
             * @param treeNode Current react tree node.
             * @param value Target expand/collapse state.
             */
            Tree.prototype.ExpandCollapse = function (treeNode, value) {
                if ($dyn.value(this.Enabled)) {
                    treeNode.Expanded(value);
                    var args = [treeNode.NodeId(), value ? $dyn.ui.Tree.ExpandAction.Expand : $dyn.ui.Tree.ExpandAction.Collapse];
                    $dyn.getFunction(this.Expanding)(args);
                }
            };
            /**
             * Select the provided node.
             * @param treeNode Current react tree node.
             * @param howSelected Medium of tree node selection.
             * @param selectionAction Tree node selection action.
             */
            Tree.prototype.SelectNode = function (treeNode, howSelected, selectionAction) {
                this.currentHowSelected = howSelected;
                if ($dyn.value(this.Enabled)) {
                    switch (selectionAction) {
                        case $dyn.ui.Tree.SelectionAction.Append:
                            this.toggleSelectedNode(treeNode, howSelected);
                            break;
                        case $dyn.ui.Tree.SelectionAction.Range:
                            var selectedNode = this.FirstSelectedNode();
                            this.selectNodeRange(selectedNode, treeNode, howSelected);
                            break;
                        default:
                            this.selectSingleNode(treeNode, howSelected);
                            break;
                    }
                }
            };
            /**
             * Compare the id of two tree nodes
             * @param left Current node information.
             * @param rightId ID to be checked with.
             * @returns True if the node id is equal to the given id
             */
            Tree.prototype.idComparer = function (left, rightId) {
                // tslint:disable-next-line: triple-equals
                return (left.Id == rightId);
            };
            /**
             * Compare the id of two tree nodes
             * @param left Current react node.
             * @param rightId ID to be checked with.
             * @returns True if the node id is equal to the given id
             */
            Tree.prototype.nodeIdComparer = function (left, rightId) {
                // tslint:disable-next-line: triple-equals
                return (left.NodeId() == rightId);
            };
            /**
             * Remove a node from an array.
             * @param array Node information of react node array.
             * @param treeNodeId Node id to remove.
             * @param nodeComparer Node id comparison function.
             */
            Tree.prototype.RemoveNodeFromArray = function (array, treeNodeId, nodeComparer) {
                if (array.length > 0) {
                    // Array.indexOf doesn't seem to find the node reliably, so don't use it
                    var foundIndex_1 = -1;
                    array.some(function (element, index) {
                        var found = false;
                        if (nodeComparer(element, treeNodeId)) {
                            foundIndex_1 = index;
                            found = true;
                        }
                        return found;
                    });
                    if (foundIndex_1 > -1) {
                        array.splice(foundIndex_1, 1);
                        this.RecordRemoveTelemetry(treeNodeId);
                    }
                }
            };
            /**
             * Convert node information to proper data types.
             * @todo Remove these conversions when the server sends the proper data type.
             * @param node Current node information.
             * @returns Converted node.
             */
            Tree.prototype.convertNode = function (node) {
                // tslint:disable:radix
                node.Id = parseInt(node.Id);
                node.ParentId = parseInt(node.ParentId);
                node.InsertAfterId = parseInt(node.InsertAfterId);
                node.Expanded = $dyn.util.stringToBoolean(node.Expanded);
                node.Selected = $dyn.util.stringToBoolean(node.Selected);
                node.HasChildren = $dyn.util.stringToBoolean(node.HasChildren);
                node.Bold = $dyn.util.stringToBoolean(node.Bold);
                node.CheckedState = parseInt(node.CheckedState);
                // tslint:enable:radix
                return node;
            };
            /**
             * Set the renderPending for the parent chain.
             * @param node Current node information.
             */
            Tree.prototype.updateParentChain = function (node) {
                while (node && !node.renderPending) {
                    node.renderPending = true;
                    // tslint:disable-next-line: triple-equals
                    if (node.ParentId == 0) {
                        return;
                    }
                    node = this.NodeData(node.ParentId);
                }
            };
            /**
             * Compare each memeber of node data and assign value if it is changed.
             * @param existingNode Reference node to be compared.
             * @param newNodeData New set of node information.
             * @param propName Property name to compare.
             */
            Tree.prototype.compareNodeValue = function (existingNode, newNodeData, propName) {
                // tslint:disable-next-line: triple-equals
                if (((existingNode[propName]) || (newNodeData[propName])) && existingNode[propName] != newNodeData[propName]) {
                    if (existingNode.ReactNode) {
                        // need to call associated react function
                        $dyn.callFunction(existingNode.ReactNode[propName], existingNode.ReactNode, newNodeData[propName]);
                        // special handling for CheckedState and Selected
                        if (propName === "CheckedState") {
                            this.SetWaitChecked(existingNode, newNodeData.CheckedState);
                        }
                    }
                    else {
                        existingNode[propName] = newNodeData[propName];
                        this.updateParentChain(existingNode);
                        // special handling for CheckedState and Expanded
                        if (propName === "CheckedState") {
                            this.SetWaitChecked(existingNode, newNodeData.CheckedState);
                        }
                        else if (propName === "Expanded" && existingNode.isDirty && existingNode.Expanded) {
                            existingNode.Nodes = existingNode.AllNodes;
                            existingNode.Nodes.forEach(function (childNode) {
                                if (childNode) {
                                    childNode.renderPending = true;
                                }
                            });
                            existingNode.isDirty = false;
                        }
                    }
                }
            };
            /**
             * Function to add a node to the parent's Nodes array.
             * @param node Node to be deleted.
             * @returns True if no further commit is needed, false otherwise.
             */
            Tree.prototype.addNode = function (node) {
                // tslint:disable-next-line: triple-equals
                var isRootNode = (node.ParentId == 0);
                var nodeArray = isRootNode ? this.Nodes : this.NodeData(node.ParentId).AllNodes;
                var changeHandled = false;
                var after = node.InsertAfterId;
                this.SetNodeData(node.Id, node);
                node.Nodes = [];
                node.AllNodes = [];
                // If the node is created as expanded then Nodes should point to tmpNode
                if (node.Expanded) {
                    node.Nodes = node.AllNodes;
                }
                // isDirty = true indicates that Nodes and AllNodes are not in synced
                // this flag is needed when the nodes are added/deleted under a collapsed parent,
                // they are not rendered immediately, rather the parent is marked as dirty,
                // so that when it get expanded it knows that it will have to re-render its children.
                node.isDirty = true;
                // renderPending indicates that the node should get rendered
                node.renderPending = true;
                node.Tree = this;
                // tslint:disable-next-line: triple-equals
                if (after != 0) {
                    nodeArray.splice(nodeArray.indexOf(this.NodeData(after)) + 1, 0, node);
                }
                else {
                    // if the after is zero, it indicates that the node should be inserted at first.
                    // after for the current first node should be updated with the new node
                    if (nodeArray.length > 0) {
                        nodeArray[0].InsertAfterId = node.Id;
                    }
                    nodeArray.unshift(node);
                }
                if (!isRootNode) {
                    var parentNode = this.NodeData(node.ParentId);
                    if (parentNode) {
                        parentNode.HasChildren = true;
                        if (parentNode.Expanded) {
                            // expanded parent node should be marked for render immediately, parent chain should be updated
                            this.updateParentChain(parentNode);
                        }
                        else {
                            // adding a child under non-expanded node makes the node dirty
                            // no render is needed from this action
                            parentNode.isDirty = true;
                            node.renderPending = false;
                            changeHandled = true;
                        }
                    }
                }
                this.RecordAddTelemetry(node.Id);
                return changeHandled;
            };
            /**
             * Function to delete a node from parent's Nodes array.
             * @param node Node to be deleted.
             * @param deleteImmediate False if the parent deletion is considered already, no need to rerender the child.
             * @returns True if no further commit is needed, false otherwise.
             */
            Tree.prototype.deleteNode = function (node, deleteImmediate) {
                var _this = this;
                deleteImmediate = (deleteImmediate === undefined) ? true : deleteImmediate;
                var changeHandled = false;
                if (node.HasChildren) {
                    var nodeData = this.NodeData(node.Id);
                    if (nodeData && nodeData.AllNodes) {
                        var cloneNodes = this.cloneArray(nodeData.AllNodes);
                        cloneNodes.forEach(function (childNode) {
                            if (childNode && _this.NodeData(childNode.Id)) {
                                _this.deleteNode(childNode, false);
                            }
                        });
                    }
                }
                // tslint:disable-next-line: triple-equals
                var isRootNode = (node.ParentId == 0);
                var removeFromArray = isRootNode ? this.Nodes : this.NodeData(node.ParentId).AllNodes;
                this.RemoveNodeFromArray(removeFromArray, node.Id, this.idComparer);
                this.RemoveNodeFromArray(this.selectedNodes, node.Id, this.nodeIdComparer);
                if (!isRootNode && deleteImmediate) {
                    // if the context exists for the parent, then re-render the parent
                    //  and return forceChange as false to indicate that the change is already taken care of
                    var parentNode = this.NodeData(node.ParentId);
                    if (parentNode) {
                        if (parentNode.Expanded) {
                            // expanded parent node should be marked for render immediately, parent chain should be updated
                            this.updateParentChain(parentNode);
                        }
                        else {
                            // deleting a child under non-expanded node makes the node dirty
                            // no render is needed from this action
                            parentNode.isDirty = true;
                            node.renderPending = false;
                            changeHandled = true;
                        }
                    }
                }
                this.SetNodeData(node.Id, undefined);
                return changeHandled;
            };
            /**
             * Function to update a node data and take immediate action if possible.
             * @param node Node to be updated.
             */
            Tree.prototype.updateNode = function (node) {
                var _this = this;
                var existingNode = this.NodeData(node.Id);
                var nodeProperties = ["name", "Expanded", "Selected", "HasChildren", "CheckedState", "Bold", "ImageName", "ImageType", "AltText"];
                nodeProperties.forEach(function (propName) {
                    _this.compareNodeValue(existingNode, node, propName);
                });
            };
            /** Function to render the tree. */
            Tree.prototype.renderTree = function () {
                // Render the react element
                if ($dyn.length(this.Nodes) === 0) {
                    // No nodes message is displayed only when the tree is empty.
                    var emptyText = React.createElement($dyn.DynReact.UI._EmptyTreeIndicator, { EmptyTreeText: $dyn.label("List_NoResultsMessage") });
                    ReactDOM.render(emptyText, this.element);
                }
                else {
                    // Create the react element and perform initial render
                    var reactTreeElement = React.createElement($dyn.DynReact.UI._TreeNodeContainer, { Nodes: this.Nodes });
                    ReactDOM.render(reactTreeElement, this.element);
                }
            };
            /** Delete all tree nodes. */
            Tree.prototype.deleteAll = function () {
                var _this = this;
                var cloneNodes = this.cloneArray(this.Nodes);
                cloneNodes.forEach(function (rootNodeData) {
                    _this.deleteNode(rootNodeData);
                });
                this.renderTree();
            };
            /** Start a node label editing. */
            Tree.prototype.RenameNode = function () {
                if (this.allowUserChanges() && $dyn.value(this.EditLabels)) {
                    var treeNode = this.SelectedNode();
                    if (treeNode) {
                        this.Editing = true;
                        treeNode.startRename();
                    }
                }
            };
            /**
             * Clone one array element to another.
             * @param array Array of objects.
             * @returns The cloned array of objects
             */
            Tree.prototype.cloneArray = function (array) {
                var newArray = [];
                array.forEach(function (value) {
                    newArray.push(value);
                });
                return newArray;
            };
            /**
             * Perform an action for children.
             * @param nodeData Current tree node information.
             * @param action Action to be performed on children.
             */
            Tree.prototype.forEachChild = function (nodeData, action) {
                var nodes = this.cloneArray(nodeData.AllNodes);
                var subNodes;
                var node;
                while (nodes.length > 0) {
                    node = nodes.shift();
                    subNodes = node.AllNodes;
                    if (subNodes.length > 0) {
                        nodes = nodes.concat(this.cloneArray(subNodes));
                    }
                    action(node);
                }
            };
            /**
             * Perform an action for parent chain.
             * @param nodeData Current tree node information.
             * @param action Action to be performed on parent hierarchy.
             */
            Tree.prototype.forEachParent = function (nodeData, action) {
                var parent = this.NodeData(nodeData.ParentId);
                while (parent) {
                    action(parent);
                    parent = this.NodeData(parent.ParentId);
                }
            };
            /**
             * This function observes the this.CascadeUpdate and updates the checked state.
             * @param treeNodeData Current tree node information.
             * @param state Target checked state.
             */
            Tree.prototype.SetWaitChecked = function (treeNodeData, state) {
                var _this = this;
                if ($dyn.value(this.CheckBoxCascade)) {
                    this.SetNodeCheckBox(treeNodeData, state);
                    return;
                }
                // If the CheckBox and the CascadeSelect property of tree is not yet set, then wait for the value to be true
                if (!this.checkBoxCascadeObserverCreated) {
                    this.checkBoxCascadeHandle = $dyn.observe(this.CheckBoxCascade, function (value) {
                        if (value) {
                            _this.SetNodeCheckBox(treeNodeData, state);
                            return false;
                        }
                    });
                    this.checkBoxCascadeObserverCreated = true;
                }
            };
            /**
             * Set checked state of a treenode.
             * @param treeNodeData Current tree node information.
             * @param state Target checked state.
             * @param sendInteraction Should send the interaction.
             */
            Tree.prototype.SetNodeCheckBox = function (treeNodeData, state, sendInteraction) {
                var _this = this;
                if (!this.SetNodeCheckBoxExecuting) {
                    // This is to stop the exponential execution of this method
                    this.SetNodeCheckBoxExecuting = true;
                    if ($dyn.value(this.CheckBoxCascade)) {
                        // If checking or unchecking, update the checkbox on all children
                        if (state !== $dyn.ui.CheckedState.Partial) {
                            this.forEachChild(treeNodeData, function (child) {
                                if (child.ReactNode) {
                                    child.ReactNode.CheckedState(state);
                                }
                                else {
                                    $dyn.setValue(child, "CheckedState", state);
                                }
                            });
                        }
                        this.forEachParent(treeNodeData, function (parent) {
                            // Assume no children are checked
                            var parentState = $dyn.ui.CheckedState.Unchecked;
                            // If we are checking the node we need to ensure that
                            // the parent is fully checked if all of its children are checked
                            var nonFullyCheckedChildren = 0;
                            var checkedChildren = 0;
                            _this.forEachChild(parent, function (child) {
                                var childState = child.ReactNode ? child.ReactNode.CheckedState() : child.CheckedState;
                                switch (childState) {
                                    case $dyn.ui.CheckedState.Checked:
                                        checkedChildren++;
                                        break;
                                    default:
                                        nonFullyCheckedChildren++;
                                        break;
                                }
                            });
                            // If we are checking the node we need to ensure that
                            // the parent is fully checked if all of its children are checked
                            if (nonFullyCheckedChildren === 0) {
                                parentState = $dyn.ui.CheckedState.Checked;
                            }
                            else if (checkedChildren > 0) {
                                // Not all of the children are checked, are any partially checked or fully checked?
                                parentState = $dyn.ui.CheckedState.Partial;
                            }
                            if (parent.ReactNode) {
                                parent.ReactNode.CheckedState(parentState);
                            }
                            else {
                                $dyn.setValue(parent, "CheckedState", parentState);
                            }
                        });
                    }
                    if (sendInteraction) {
                        // Call the NodeCheckedCommand command
                        var args = [treeNodeData.Id, state];
                        $dyn.getFunction(this.NodeChecked)(args);
                    }
                    this.SetNodeCheckBoxExecuting = false;
                }
            };
            /**
             * Select a single tree node.
             * @param treeNode Current react tree node.
             * @param howSelected Medium of tree node selection.
             */
            Tree.prototype.selectSingleNode = function (treeNode, howSelected) {
                // Select the treeNode if it is not already selected
                if (this.selectedNodes.length !== 1 || !treeNode.Selected()) {
                    this.ClearSelection();
                    treeNode.Selected(true);
                    var args = [treeNode.NodeId(), howSelected, false];
                    $dyn.getFunction(this.SelectionChanged)(args);
                }
            };
            /**
             * Toggle a tree node selection.
             * @param treeNode Current react tree node.
             * @param howSelected Medium of tree node selection.
             */
            Tree.prototype.toggleSelectedNode = function (treeNode, howSelected) {
                var selected = treeNode.Selected();
                treeNode.Selected(!selected);
                var args = [treeNode.NodeId(), howSelected];
                $dyn.getFunction(this.ToggleSelection)(args);
            };
            /**
             * Select a range of nodes.
             * @param treeNodeFrom Starting react tree node.
             * @param treeNodeTo Ending react tree node.
             * @param howSelected Medium of tree node selection.
             */
            Tree.prototype.selectNodeRange = function (treeNodeFrom, treeNodeTo, howSelected) {
                this.ClearSelection();
                var treeNode = this.GetRoot();
                var fromId = treeNodeFrom.NodeId();
                var toId = treeNodeTo.NodeId();
                // This loop determines which node comes first in the tree
                // tslint:disable-next-line: triple-equals
                while ((treeNode != null) && (treeNode.NodeId() != fromId) && (treeNode.NodeId() != toId)) {
                    treeNode = this.GetNextVisible(treeNode);
                }
                if (treeNode != null) {
                    // Set endId to the id of the node at the bottom
                    // tslint:disable-next-line: triple-equals
                    var endId = (treeNode.NodeId() == toId) ? fromId : toId;
                    while (treeNode != null) {
                        treeNode.Selected(true);
                        // tslint:disable-next-line: triple-equals
                        if (treeNode.NodeId() == endId) {
                            break;
                        }
                        else {
                            // We are only moving down the tree, so we will never need to call GetPrevVisible here.
                            treeNode = this.GetNextVisible(treeNode);
                        }
                    }
                }
                var args = [treeNodeFrom.NodeId(), treeNodeTo.NodeId()];
                $dyn.getFunction(this.SelectRange)(args);
            };
            /**
             * Get the first selected node.
             * @returns First selected react node.
             */
            Tree.prototype.FirstSelectedNode = function () {
                var selectedNode = null;
                if (this.selectedNodes.length > 0) {
                    selectedNode = this.selectedNodes[0];
                }
                return selectedNode;
            };
            /**
             * Get the latest selected node.
             * @returns Selected react node.
             */
            Tree.prototype.SelectedNode = function () {
                var selectedNode = null;
                if (this.selectedNodes.length > 0) {
                    selectedNode = this.selectedNodes[this.selectedNodes.length - 1];
                }
                return selectedNode;
            };
            /**
             * Update the scroll position if the selected node is not in the view.
             * @param treeNode Selected React tree node.
             */
            Tree.prototype.updateScrollIntoView = function (treeNode) {
                if (treeNode && this.currentHowSelected !== 1) {
                    // If the selected node is not on Screen, call scrollIntoView for the node.
                    treeNode.InputElement().scrollIntoView(false);
                }
                this.currentHowSelected = 0;
            };
            /** Clears all the selected nodes. */
            Tree.prototype.ClearSelection = function () {
                this.selectedNodes.forEach(function (value) {
                    value.Selected(false, true);
                });
                this.selectedNodes = [];
            };
            /**
             * Get root node.
             * @returns Root react node
             */
            Tree.prototype.GetRoot = function () {
                var rootNode = null;
                if (this.Nodes.length > 0) {
                    rootNode = this.Nodes[0].ReactNode;
                }
                return rootNode;
            };
            /**
             * Get the parent node.
             * @param treeNode Current react tree node.
             * @returns Parent react node.
             */
            Tree.prototype.GetParentNode = function (treeNode) {
                var parentNode = null;
                if (treeNode) {
                    var parent_1 = this.NodeData(treeNode.ParentId());
                    if (parent_1) {
                        parentNode = parent_1.ReactNode;
                    }
                }
                return parentNode;
            };
            /**
             * Expand the selected node.
             * @returns Boolean value.
             */
            Tree.prototype.ExpandSelectedNode = function () {
                var selectedNode = this.SelectedNode();
                // tslint:disable-next-line: triple-equals
                if (selectedNode && selectedNode.HasChildren() == true) {
                    selectedNode.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                    this.ExpandCollapse(selectedNode, true);
                    return false;
                }
            };
            /** Collapse the selected node. */
            Tree.prototype.CollapseSelectedNode = function () {
                var selectedNode = this.SelectedNode();
                // tslint:disable-next-line: triple-equals
                if (selectedNode && selectedNode.HasChildren() == true && selectedNode.Expanded() == true) {
                    selectedNode.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                    this.ExpandCollapse(selectedNode, false);
                }
                else {
                    var parentNode = this.GetParentNode(selectedNode);
                    if (parentNode) {
                        this.SelectNode(parentNode, $dyn.ui.Tree.HowSelected.ByKeyboard);
                        parentNode.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        this.ExpandCollapse(parentNode, false);
                    }
                }
            };
            /**
             * Toggle the checked state of the selected node.
             * @param evt The key down event.
             */
            Tree.prototype.ToggleSelectedNodeCheck = function (evt) {
                var selectedNode = this.SelectedNode();
                selectedNode.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                this.CheckBoxClick(selectedNode, evt);
            };
            /**
             * Get the next visible node.
             * @param startNode Current react node.
             * @returns Next visible react node
             */
            Tree.prototype.GetNextVisible = function (startNode) {
                var nextVisible = null;
                if (startNode && startNode.Expanded() && startNode.ChildCount()) {
                    nextVisible = startNode.GetChild(0);
                }
                else {
                    nextVisible = this.GetSiblingNode(startNode, true);
                    // If there were no sibling nodes, get the next sibling of the parent
                    while ((!nextVisible) && (startNode)) {
                        startNode = this.GetParentNode(startNode);
                        nextVisible = this.GetSiblingNode(startNode, true);
                    }
                }
                return nextVisible;
            };
            /**
             * Get the previous visible node.
             * @param startNode Current react node.
             * @returns Previous visible react node.
             */
            Tree.prototype.GetPrevVisible = function (startNode) {
                var prevVisible = this.GetSiblingNode(startNode, false);
                if (prevVisible === null) {
                    prevVisible = this.GetParentNode(startNode);
                }
                else if (prevVisible.Expanded() && prevVisible.ChildCount()) {
                    var nodeToReturn = prevVisible;
                    while (nodeToReturn && nodeToReturn.Expanded() && nodeToReturn.ChildCount()) {
                        prevVisible = nodeToReturn;
                        nodeToReturn = nodeToReturn.GetChild(nodeToReturn.ChildCount() - 1);
                    }
                    return nodeToReturn ? nodeToReturn : prevVisible;
                }
                return prevVisible;
            };
            /**
             * Get the sibling node of a given node.
             * @param treeNode Current tree node React object.
             * @param forward Direction, next if true.
             * @returns Sibling react node.
             */
            Tree.prototype.GetSiblingNode = function (treeNode, forward) {
                var siblingNode = null;
                if (treeNode) {
                    var nodeDataList = this.Nodes;
                    var treeNodeData = this.NodeData(treeNode.NodeId());
                    var parentNode = this.GetParentNode(treeNode);
                    if (parentNode) {
                        nodeDataList = parentNode.GetChildren();
                    }
                    var nodeIndex = nodeDataList.indexOf(treeNodeData);
                    if (nodeIndex >= 0) {
                        var siblingNodeContract = null;
                        if (forward === true) {
                            siblingNodeContract = nodeDataList[nodeIndex + 1];
                        }
                        else {
                            siblingNodeContract = nodeDataList[nodeIndex - 1];
                        }
                        if (siblingNodeContract) {
                            siblingNode = siblingNodeContract.ReactNode;
                        }
                    }
                }
                return siblingNode;
            };
            /**
             * Get sibling information of a given node.
             * @param treeNodeData Current tree node data.
             * @param forward Direction, next if true.
             * @returns Sibling node information.
             */
            Tree.prototype.GetSiblingData = function (treeNodeData, forward) {
                var siblingNode = null;
                if (treeNodeData) {
                    var nodeDataList = this.Nodes;
                    var parentNodeData = this.NodeData(treeNodeData.ParentId);
                    if (parentNodeData) {
                        nodeDataList = parentNodeData.AllNodes;
                    }
                    var nodeIndex = nodeDataList.indexOf(treeNodeData);
                    if (nodeIndex >= 0) {
                        if (forward === true) {
                            siblingNode = nodeDataList[nodeIndex + 1];
                        }
                        else {
                            siblingNode = nodeDataList[nodeIndex - 1];
                        }
                    }
                }
                return siblingNode;
            };
            /** Select the first root. */
            Tree.prototype.SelectRoot = function () {
                var rootNode = this.GetRoot();
                this.SelectNode(rootNode, $dyn.ui.Tree.HowSelected.ByKeyboard, $dyn.ui.Tree.SelectionAction.Single);
            };
            /** Select the first root. */
            Tree.prototype.SelectLastVisibleRoot = function () {
                var currentNode = this.SelectedNode();
                var nextNode = currentNode;
                while (currentNode != null) {
                    currentNode = this.GetNextVisible(currentNode);
                    if (currentNode != null) {
                        nextNode = currentNode;
                    }
                }
                this.SelectNode(nextNode, $dyn.ui.Tree.HowSelected.ByKeyboard, $dyn.ui.Tree.SelectionAction.Single);
            };
            /**
             * Select the next visible node
             * @param evt The key down event.
             * @param isNext Selection direction, forward if true.
             * @returns False if the selected node and next visible node aren't null, otherwise it returns undefined.
             */
            Tree.prototype.SelectNextVisible = function (evt, isNext) {
                var selectedNode = this.SelectedNode();
                var nextVisible = isNext ? this.GetNextVisible(selectedNode) : this.GetPrevVisible(selectedNode);
                if (selectedNode !== null && nextVisible !== null) {
                    if (!$dyn.value(this.SingleSelect) && (evt.shiftKey || evt.ctrlKey)) {
                        var nodeToAppend = void 0;
                        if (this.selectedNodes.length === 1) {
                            nodeToAppend = nextVisible;
                            this.direction = isNext ? $dyn.ui.Tree.NavigationDirection.Down : $dyn.ui.Tree.NavigationDirection.Up;
                        }
                        else if (isNext && this.direction === $dyn.ui.Tree.NavigationDirection.Down) {
                            nodeToAppend = nextVisible;
                        }
                        else if (!isNext && this.direction === $dyn.ui.Tree.NavigationDirection.Up) {
                            nodeToAppend = nextVisible;
                        }
                        else {
                            nodeToAppend = selectedNode;
                        }
                        this.toggleSelectedNode(nodeToAppend, $dyn.ui.Tree.HowSelected.ByKeyboard);
                    }
                    else {
                        this.SelectNode(nextVisible, $dyn.ui.Tree.HowSelected.ByKeyboard, $dyn.ui.Tree.SelectionAction.Single);
                        this.direction = isNext ? $dyn.ui.Tree.NavigationDirection.Down : $dyn.ui.Tree.NavigationDirection.Up;
                    }
                    return false;
                }
            };
            /**
             * Handle the tree node label edit action.
             * @param evt The key down event.
             * @param shouldRollBack Flag indicating if the label edit should be rolled back.
             */
            Tree.prototype.handleRenameActions = function (evt, shouldRollBack) {
                var selectedNode = this.SelectedNode();
                if (shouldRollBack) {
                    selectedNode.rollbackChange(evt);
                }
                else {
                    selectedNode.commitChange(evt);
                }
            };
            /**
             * Function checks if in zoom mode if we are changing row inside a sidepanel close the side panel if we are for responsive
             */
            Tree.prototype.formActiveRowChangedNotify = function () {
                if ($dyn.util.isInZoomWidthMode() && this.isElementInSidePanel()) {
                    // close sidePanel
                    var sidePanel = this.Root.SidePanel;
                    if (sidePanel && sidePanel.SidePanelElement && $dyn.context(sidePanel.SidePanelElement).Visible) {
                        // trigger close
                        sidePanel.toggleVisibility();
                    }
                }
            };
            /**
             * Function checks if in element is in the side panel
             * @returns {boolean} true if in the sidePanel
             */
            Tree.prototype.isElementInSidePanel = function () {
                if (this.elementInSidePanel === undefined) {
                    this.elementInSidePanel = false;
                    if (this.element.parentElement && this.element.parentElement.parentElement && this.element.parentElement.parentElement.classList.contains("SidePanel")) {
                        this.elementInSidePanel = true;
                    }
                }
                return this.elementInSidePanel;
            };
            return Tree;
        }($dyn.ui.Control));
        controls.Tree = Tree;
        Tree.prototype.CascadeSelect = true;
        Tree.prototype.Border = "Auto";
        Tree.prototype.RootNodeId = null;
        Tree.prototype.SetSelection = null;
        Tree.prototype.ExpandTree = null;
        Tree.prototype.CheckBox = false;
        Tree.prototype.EditLabels = false;
        Tree.prototype.Editing = false;
        Tree.prototype.HasButtons = false;
        Tree.prototype.TreeNodes = null;
        Tree.prototype.Expanding = null;
        Tree.prototype.SelectionChanged = null;
        Tree.prototype.SingleSelect = false;
        Tree.prototype.NodeNameChanged = null;
        Tree.prototype.NodeChecked = null;
        Tree.prototype.TransitStateSubscriptionId = null;
        Tree.prototype.Nodes = null;
        $dyn.ui.addObservablePropertiesToPrototype(Tree.prototype, { TreeNodes: null });
    })(controls = $dyn.controls || ($dyn.controls = {}));
    var ui;
    (function (ui) {
        /** Enum type for tree node action. */
        var TreeCommands;
        (function (TreeCommands) {
            TreeCommands[TreeCommands["Delete"] = 0] = "Delete";
            TreeCommands[TreeCommands["Add"] = 1] = "Add";
            TreeCommands[TreeCommands["Edit"] = 2] = "Edit";
        })(TreeCommands = ui.TreeCommands || (ui.TreeCommands = {}));
        /** Enum type for tri-state check. */
        var CheckedState;
        (function (CheckedState) {
            CheckedState[CheckedState["Unchecked"] = 0] = "Unchecked";
            CheckedState[CheckedState["Checked"] = 1] = "Checked";
            CheckedState[CheckedState["Partial"] = 2] = "Partial";
        })(CheckedState = ui.CheckedState || (ui.CheckedState = {}));
        var Tree;
        (function (Tree) {
            /** Tree node action type. */
            var ExpandAction;
            (function (ExpandAction) {
                ExpandAction[ExpandAction["Collapse"] = 1] = "Collapse";
                ExpandAction[ExpandAction["Expand"] = 2] = "Expand";
            })(ExpandAction = Tree.ExpandAction || (Tree.ExpandAction = {}));
            /** Enum type for tree node selection method. */
            var HowSelected;
            (function (HowSelected) {
                HowSelected[HowSelected["Unknown"] = 0] = "Unknown";
                HowSelected[HowSelected["ByMouse"] = 1] = "ByMouse";
                HowSelected[HowSelected["ByKeyboard"] = 2] = "ByKeyboard";
            })(HowSelected = Tree.HowSelected || (Tree.HowSelected = {}));
            /** Enum type for tree node selection action. */
            var SelectionAction;
            (function (SelectionAction) {
                SelectionAction[SelectionAction["Single"] = 0] = "Single";
                SelectionAction[SelectionAction["Append"] = 1] = "Append";
                SelectionAction[SelectionAction["Range"] = 2] = "Range";
            })(SelectionAction = Tree.SelectionAction || (Tree.SelectionAction = {}));
            /** Enum type for tree navigation direction. */
            var NavigationDirection;
            (function (NavigationDirection) {
                NavigationDirection[NavigationDirection["Up"] = 1] = "Up";
                NavigationDirection[NavigationDirection["Down"] = 2] = "Down";
            })(NavigationDirection = Tree.NavigationDirection || (Tree.NavigationDirection = {}));
            /** Enum type for accessibility action performed on a tree node. */
            var AccessibilityAction;
            (function (AccessibilityAction) {
                AccessibilityAction[AccessibilityAction["SelectionChanged"] = 1] = "SelectionChanged";
                AccessibilityAction[AccessibilityAction["ExpandedChanged"] = 2] = "ExpandedChanged";
                AccessibilityAction[AccessibilityAction["CheckedStateChanged"] = 3] = "CheckedStateChanged";
            })(AccessibilityAction = Tree.AccessibilityAction || (Tree.AccessibilityAction = {}));
        })(Tree = ui.Tree || (ui.Tree = {}));
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Tree.js.map
